module.exports = __webpack_public_path__ + "img/title-news.020fbd3c.svg";